import React from "react";
import "./LanguageSwitcher.scss";

export const LanguageSwitcher = ({ currentLanguage, onLanguageChange }) => {
  return (
    <div className="language-switcher">
      <select
        className="language-switcher__select"
        value={currentLanguage}
        onChange={(e) => onLanguageChange(e.target.value)}
        aria-label="Select language"
      >
        <option value="en">EN</option>
        <option value="sr">SR</option>
      </select>
    </div>
  );
};
